<template>
  <div class="tabs-cls">
    <el-tabs v-model="indexTerm">
      <el-tab-pane :label="term.value" v-for="(term, index) in list" :name="index + ''"></el-tab-pane>
    </el-tabs>
    <div class="btn-group-cls">
      <button type="button" @click="handleHall" v-if="hallSiteOpen == '1'">大厅位置分布查询</button>
      <button type="button" @click="goMyAppointMent">已预约信息查询</button>
    </div>
  </div>
</template>
<script>
import * as requestUrls from '@/utils/appointment.url';

export default {
  data: function() {
    return {
      num: 0,
      list: this.tabsList,
      hallSiteOpen: '0',
      term: null,
      indexTerm: '0'
    }
  },
  props: ['tabsList'],
  watch: {
    'tabsList': function(n, o) {
      this.list = this.tabsList;
    },
    indexTerm(i) {
      this.$emit('transmit', this.list[parseInt(i)]);
    }
  },
  methods: {
    goMyAppointMent() {
      this.$router.push({
        path: '/myAppointMent'
      })
    },
    handleHall() {
      window.open(`https://wx.gdd.gov.cn/ApprGovernmentGuide/index.html#/index`);
    }
  },
  mounted() {
    // 禅道8106
    requestUrls.getConfigurationInformation({}, 'GET').then(res => {
      if (+res.status === 200) {
        this.hallSiteOpen = res.data.hallSiteOpen;
      } else {
        this.$message.error(res.desc);
      }
    }).catch(err => {
      console.log(err);
    })
  }
}
</script>
<style lang="scss">
.tabs-cls {
  position: relative;

  .el-tabs__item {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0D1C28;
    height: 55px;
  }

  .el-tabs__nav-wrap::after {
    height: 3px;
    background: #0D1C28;
  }

  .el-tabs__item.is-active {
    color: $main-color;
  }

  .el-tabs__active-bar {
    height: 3px;
  }

  .btn-group-cls {
    position: absolute;
    top: 12px;
    left: auto;
    right: 0px;

    button {
      background: none;
      border: none;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: $main-color;
      line-height: 22px;
      cursor: pointer;
    }
  }
}
</style>